import type { EventProperties } from './types';

const DATA_OBSERVE_PREFIX = 'data-observe-';
const RESERVED_ATTRIBUTES = new Set(['id', 'view']);

/**
 * Extracts custom properties from data-observe-* attributes on an element,
 * excluding reserved attributes (id, view) which are used for identification.
 */
export const extractProperties = (element: Element): EventProperties =>
  Object.fromEntries(
    Array.from(element.attributes)
      .filter(
        (attr) =>
          attr.name.startsWith(DATA_OBSERVE_PREFIX) &&
          !RESERVED_ATTRIBUTES.has(attr.name.slice(DATA_OBSERVE_PREFIX.length))
      )
      .map((attr) => [attr.name.slice(DATA_OBSERVE_PREFIX.length), attr.value])
  );
